import { NotificationTemplate } from '@ail/notifications-api'
import { useMemo, useState } from 'react'
import { useGetNotificationsQuery, useLazyGetNotificationsQuery } from '../../../redux/api/notificationsApi'
import CheckToggle from '../../common/CheckToggle/CheckToggle'
import Modal from '../../common/Modal/Modal'
import ActivityItem from './ActivityItem/ActivityItem'
import FullViewLastActivities from './FullViewLastActivities'
import './LastActivities.scss'

export default function LastActivities() {
  const initialNotifications = useGetNotificationsQuery({})
  const [fetchNotifications, newNotifications] = useLazyGetNotificationsQuery()

  function getNotificationIcon(notificationType?: string) {
    switch (notificationType) {
      case NotificationTemplate.ApprovalDeclined:
      case NotificationTemplate.ApprovalGranted:
        return 'icon-requests'
      case NotificationTemplate.OrderFrozen:
      case NotificationTemplate.OrderSupplierFieldUpdated:
        return 'icon-garageInOut'
      case NotificationTemplate.ReportAvailable:
        return 'icon-report'
      default:
        return 'icon-alert'
    }
  }

  const notifications = useMemo(() => {
    if (!initialNotifications.currentData) return undefined
    return newNotifications.currentData ?? initialNotifications.currentData
  }, [initialNotifications.currentData, newNotifications.currentData])

  function getAlertsOnly(value: boolean) {
    if (value) {
      fetchNotifications({ templateNames: ['ReportAvailable'] })
    } else {
      fetchNotifications({})
    }
  }

  const [fullView, setFullView] = useState(false)
  return (
    <>
      <div className="lastActivities">
        <div className="box-title">
          <span>
            <i className="icon-alert" />
            Last activities
          </span>
          <div className="alertSection">
            <CheckToggle onClick={getAlertsOnly} />
            <label htmlFor="alertOnly">Alert Only</label>
            <i className="icon icon-warning" />
          </div>
        </div>
        <div className="box3">
          {notifications && (
            <>
              <ul className="activityList">
                {notifications.notifications
                  .map((n) => <ActivityItem item={n} icon={getNotificationIcon(n.templateName)} />)
                  .splice(0, 5)}
              </ul>

              {notifications.totalCount > 5 && (
                <button className="viewAll" onClick={() => setFullView(true)}>
                  View All
                </button>
              )}
            </>
          )}
        </div>
      </div>
      {fullView && notifications && (
        <Modal
          visible={true}
          detailsCustomClass="activitiesModal"
          onClose={() => setFullView(false)}
          title="Activities and alerts"
          icon="icon-alert"
        >
          <FullViewLastActivities
            onClose={() => setFullView(false)}
            data={notifications}
            totalCount={notifications.totalCount}
            iconGetter={getNotificationIcon}
          />
        </Modal>
      )}
    </>
  )
}
